<template>
    <select class="form-control">
        <option v-if="hasNone" value="">-- None --</option>
        <slot></slot>
    </select>
</template>

<script>
import $ from 'jquery';

export default {
  name: 'DropDownList',

  props: {
    value: {
      type: String,
      required: false,
      default: undefined,
    },
    options: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    hasNone: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      selected: null,
    };
  },

  mounted() {
    if (this.value && this.value.includes(';')) {
      this.selected = this.value.split(';');
    } else {
      this.selected = this.value;
    }

    const element = $(this.$el)
      .select2({
        ...this.options,
        allowClear: false,
      });

    if (this.value) {
      element.val(this.value);
    }

    element.trigger('change')
    // emit event on change.
      .on('change', () => {
        if (Array.isArray(element.val())) {
          this.selected = element.val()
            .filter((v) => v !== '');
        }

        this.$emit('input', this.selected);
      });
  },
  watch: {
    selected(value, oldValue) {
      if (JSON.stringify(value) === JSON.stringify(oldValue)) return;

      $(this.$el)
        .val(value)
        .trigger('change');
    },
    value(value) {
      // update value
      $(this.$el)
        .val(value)
        .trigger('change');
    },
    options(options) {
      // update options
      $(this.$el)
        .empty()
        .select2({
          ...options,
          allowClear: false,
        });
    },
  },
  destroyed() {
    $(this.$el)
      .off()
      .select2('destroy');
  },
};
</script>
